import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getFieldValuesKey } from "./useGetFieldValues";
import { useSnackbar } from "src/utils/useSnackbar";
import { AxiosError } from "axios";

export const deleteFieldValueKey = "updateFieldValue" as const;

type Options = {
    actionPlanId: string;
    actionPlanActionId: string;
    fieldValueId: number | null;
    onSuccess?: () => void;
    onError?: (error: any) => void;
};

export const useDeleteFieldValue = (options: Options) => {
    const { actionPlanId, actionPlanActionId, fieldValueId = null, onSuccess, onError } = options;
    const queryClient = useQueryClient();
    const snackbar = useSnackbar();

    const mutation = useMutation({
        mutationKey: [deleteFieldValueKey, actionPlanActionId, fieldValueId],
        mutationFn: async () => {
            const response = await loggedInApiCall.delete(
                `/api/action_plan_actions/${actionPlanActionId}/field_values/${fieldValueId}`,
            );

            return response;
        },
        onSuccess: () => {
            // Invalidate related queries to refresh the UI
            queryClient.invalidateQueries([`getOneActionPlanActions`, actionPlanActionId, actionPlanId]);
            queryClient.invalidateQueries([`action_plan_action_property_contributions`]);
            queryClient.invalidateQueries([`action_plan_action_field_values`]);

            queryClient.invalidateQueries([getFieldValuesKey, actionPlanActionId]);

            onSuccess?.();
        },
        onError: (error: AxiosError<any>) => {
            console.error("Error deleting field value:", error);

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "error",
                message: error?.response?.data?.["hydra:description"] ?? error?.message,
                forceAutoHideInMilisecond: 10000,
            });
            onError?.(error);
        },
    });

    return mutation;
};
